import React, { useEffect, useState } from 'react';
import { Col, Row } from "react-bootstrap";
import { Dispatch, bindActionCreators, AnyAction } from 'redux';
import { connect } from 'react-redux';
import { AppState } from '../store/configureStore';
import Skeleton from "react-loading-skeleton";
import { detailsActionCreators } from '../store/DetailsStore';


type TContributionSummaryProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
const ContributionSummary = (props: TContributionSummaryProps) => {

    const [offset, setOffset] = useState(0);

    const getOffset = () => {
        setOffset(props.cmContributionSummary?.cmSummaryInfo?.summary?.contribs?.find(x => x.name === "Payment Account:") ? 4 : 3)
    }
    useEffect(() => {
        if (props.cmContributionSummary?.isSummaryLoaded) {
            getOffset();
        }

    }, [props.cmContributionSummary?.isSummaryLoaded]);

    return (
        <>
            <Row>
                <Col>
                    {props.cmContributionSummary?.isSummaryLoading && props.cmContributionSummary?.isLoading ?
                        <LoadingSkeletonForSummary />
                        :
                        <>
                            <div>
                                {props.cmContributionSummary?.cmSummaryInfo?.summary?.contribs?.map((item, i) =>
                                    <Row key={i}>
                                        {i < props.cmContributionSummary?.cmSummaryInfo?.summary?.contribs?.length - (offset) &&
                                            <>
                                                <Col className="col-7">
                                                <span className="control-label">{item.name}</span>
                                                </Col>
                                                <Col className="col-5 pl-0">
                                                <span className="control-value ">{item.value}</span>
                                                </Col>
                                            </>
                                        }
                                        {i === props.cmContributionSummary?.cmSummaryInfo?.summary.contribs?.length - (offset) &&
                                            <>
                                                <Col className="col-7 mt-2">
                                                    <span className="font-weight-bold">{item.name}</span>
                                                </Col>
                                            <Col className="col-5 pl-0 mt-2">
                                                    <span className="font-weight-bold">{item.value}</span>
                                                </Col>
                                            </>
                                        }
                                        {i === props.cmContributionSummary?.cmSummaryInfo?.summary?.contribs?.length - (offset - 1) &&
                                            <>
                                            <Col className="col-7">
                                                <span className="control-label">{item.name}</span>
                                                </Col>
                                            <Col className="col-5 pl-0">
                                                <span className="control-value ">{item.value}</span>
                                                </Col>
                                            </>
                                        }
                                        {i === props.cmContributionSummary?.cmSummaryInfo?.summary.contribs?.length - (offset - 2) &&
                                            <>
                                            <Col className="col-7 mb-2">
                                                <span className="font-weight-bold control-label">{item.name}</span>
                                                </Col>
                                            <Col className="col-5 mb-2 pl-0">
                                                    <span className="font-weight-bold">{item.value}</span>
                                                </Col>
                                            </>
                                        }
                                        {i === props.cmContributionSummary?.cmSummaryInfo?.summary.contribs?.length - (offset - 3) &&
                                            <>
                                            <Col className="col-12 mt-2">
                                                <span className="font-weight-bold control-label">{item.name}</span>
                                                </Col>
                                            <Col className="col-12 mb-2">
                                                <span className="control-value ">{item.value}</span>
                                                </Col>
                                            </>
                                        }
                                    </Row>
                                )}
                            </div>
                        </>
                    }
                </Col>
            </Row>
        </>
    )
}
const LoadingSkeletonForSummary = () => (
    <div className="row">
        <div className="col-7 pl-0">
            <div className="mt-2"><Skeleton width={'20em'} /></div>
            <div className="mt-2"><Skeleton width={'20em'} /></div>
            <div><Skeleton width={'15em'} /></div>
            <div><Skeleton width={'15em'} /></div>
            <div><Skeleton width={'15em'} /></div>
            <div><Skeleton width={'15em'} /></div>
            <div><Skeleton width={'15em'} /></div>
            <div className="mt-3"><Skeleton width={'20em'} /></div>
            <div><Skeleton width={'15em'} /></div>
            <div className="mt-3"><Skeleton width={'20em'} /></div>
            <div className="mt-3">
                <div className="mt-3"><Skeleton width={'15em'} /></div>
                <div><Skeleton width={'15em'} /></div>
                <div><Skeleton width={'15em'} /></div>
                <div><Skeleton width={'15em'} /></div>
                <div className="mt-3"><Skeleton width={'15em'} /></div>
                <div className="mt-2"><Skeleton width={'20em'} /></div>
            </div>
        </div>
        <div className="col-4 pl-0"></div>
    </div>
);

function mapStateToProps(state: AppState) {
    return {
        cmContributionSummary: state.cmDetails
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({ ...detailsActionCreators }, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ContributionSummary);